import * as React from 'react';

export function Tag({ text, ...rest }) {
    return (
        <span data-testid="tag-container" style={{ color: '#0070fa' }} {...rest}>
            {text}
        </span>
    );
}
